import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { getFormSubList } from './api/forms';
import toastManager from './utils/toastManager';
import TopNavbar from './components/TopNavbar';
import ExportExcelModal from './components/ExportExcelModal';

// 删除填写记录API
async function deleteSubFormById(id) {
  try {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
    const res = await fetch(`${API_BASE_URL}/forms/deleteSubForm/${id}`, {
      method: 'GET',
      credentials: 'include',
    });
    const data = await res.json();
    if (data.code === 200) {
              // 删除成功，不显示提示
      return true;
    } else {
      toastManager && toastManager.error(data.message || '删除失败');
      return false;
    }
  } catch (e) {
    toastManager && toastManager.error('删除失败');
    return false;
  }
}

export default function FormSubmissionsPage() {
  const { formId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [size] = useState(10); // 每页条数
  const [total, setTotal] = useState(0);
  const [showExportModal, setShowExportModal] = useState(false);

  // 从URL参数或state中获取返回信息
  const getReturnInfo = () => {
    const searchParams = new URLSearchParams(location.search);
    const fromState = location.state;
    
    return {
      from: searchParams.get('from') || fromState?.from || 'all', // 默认返回全部
      page: parseInt(searchParams.get('page')) || fromState?.page || 1, // 默认第1页
      tab: searchParams.get('tab') || fromState?.tab || 'all' // 默认全部标签
    };
  };

  const returnInfo = getReturnInfo();

  // 格式化时间为年月日
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString; // 如果解析失败，返回原字符串
      return date.toISOString().split('T')[0]; // 返回 YYYY-MM-DD 格式
    } catch (e) {
      return dateString; // 出错时返回原字符串
    }
  };

  // 导出Excel功能
  const handleExport = () => {
    setShowExportModal(true);
  };

  // 返回功能
  const handleBack = () => {
    const { from, page, tab } = returnInfo;
    
    if (from === 'personal') {
      // 返回到个人表单列表
      navigate(`/forms?tab=personal&page=${page}`);
    } else {
      // 返回到全部表单列表
      navigate(`/forms?tab=${tab}&page=${page}`);
    }
  };

  useEffect(() => {
    async function fetchRecords() {
      setLoading(true);
      setError('');
      try {
        // 调用 getFormSubList，参数为 formId 和分页参数
        const res = await getFormSubList(formId, { page, size });
        // 兼容后端返回结构
        const list = res.data?.list || [];
        setRecords(list);
        setTotal(res.data?.total || 0);
      } catch (e) {
        setError('获取填写记录失败');
      }
      setLoading(false);
    }
    fetchRecords();
  }, [formId, page, size]);

  // 解析所有 submissionData
  const parsedRecords = records.map(rec => ({
    ...rec,
    parsedData: rec.submissionData ? JSON.parse(rec.submissionData) : {}
  }));

  // 获取所有字段名（合并所有记录的key，防止有的记录字段不全）
  const allKeys = Array.from(
    new Set(parsedRecords.flatMap(rec => Object.keys(rec.parsedData)))
  );

  const totalPages = Math.max(1, Math.ceil(total / size));

  return (
    <div style={{ background: '#f4f6fa', minHeight: '100vh' }}>
      <TopNavbar />
      <div style={{ width: '100%', margin: '40px 0', background: '#fff', borderRadius: 12, padding: '20px 8px', minHeight: 400, boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
        <button onClick={handleBack} style={{ marginBottom: 24, background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, padding: '10px 32px', fontSize: 16, cursor: 'pointer', fontWeight: 500, boxShadow: '0 2px 8px rgba(24,144,255,0.08)' }}>返回</button>
        <button
          onClick={handleExport}
          style={{
            marginLeft: 16,
            marginBottom: 24,
            background: '#52c41a',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            padding: '10px 32px',
            fontSize: 16,
            cursor: 'pointer',
            fontWeight: 500,
            boxShadow: '0 2px 8px rgba(82,196,26,0.08)'
          }}
        >
          导出Excel
        </button>
        <h2 style={{ marginBottom: 28, fontWeight: 700, fontSize: 26, color: '#222' }}>表单填写记录</h2>
        {loading ? (
          <div style={{ color: '#999', padding: 40, textAlign: 'center' }}>加载中...</div>
        ) : error ? (
          <div style={{ color: '#ff7875', padding: 40, textAlign: 'center' }}>{error}</div>
        ) : parsedRecords.length === 0 ? (
          <div style={{ color: '#bbb', padding: 40, textAlign: 'center' }}>暂无填写记录</div>
        ) : (
          <>
            <div style={{ overflowX: 'auto' }}>
              <table className="copyable-table" style={{ width: '100%', borderCollapse: 'collapse', fontSize: 15, background: '#fff', borderRadius: 10, overflow: 'hidden', boxShadow: '0 2px 8px rgba(24,144,255,0.04)' }}>
                <thead>
                  <tr style={{ background: '#f7f7fa' }}>
                    <th style={{ padding: '12px', border: '1px solid #eee', fontWeight: 600, color: '#222', fontSize: 16 }}>序号</th>
                    <th style={{ padding: '12px', border: '1px solid #eee', fontWeight: 600, color: '#222', fontSize: 16 }}>微信昵称</th>
                    {allKeys.map(key => (
                      <th key={key} style={{ padding: '12px', border: '1px solid #eee', fontWeight: 600, color: '#222', fontSize: 16 }}>{key}</th>
                    ))}
                    <th style={{ padding: '12px', border: '1px solid #eee', fontWeight: 600, color: '#222', fontSize: 16 }}>提交时间</th>
                    <th style={{ padding: '12px', border: '1px solid #eee', fontWeight: 600, color: '#222', fontSize: 16 }}>操作</th>
                  </tr>
                </thead>
                <tbody>
                  {parsedRecords.map((rec, idx) => (
                    <tr key={rec.id || idx} style={{ background: idx % 2 === 0 ? '#fff' : '#f7f9fc' }}>
                      <td style={{ padding: '10px', border: '1px solid #eee', textAlign: 'center', color: '#1890ff', fontWeight: 600 }}>{(page - 1) * size + idx + 1}</td>
                      <td style={{ padding: '10px', border: '1px solid #eee', color: '#666' }}>{rec.nickName || '-'}</td>
                      {allKeys.map(key => (
                        <td key={key} style={{ padding: '10px', border: '1px solid #eee' }}>
                          {(() => {
                            const v = rec.parsedData[key];
                            if (v && typeof v === 'object' && v.brand && v.store) {
                              return `${v.brand}${v.store ? '-' + v.store : ''}`;
                            }
                            if (typeof v === 'object') {
                              return JSON.stringify(v);
                            }
                            return v || '';
                          })()}
                        </td>
                      ))}
                      <td style={{ padding: '10px', border: '1px solid #eee', color: '#888' }}>{formatDate(rec.submittedAt || rec.createdAt || rec.created_at || '')}</td>
                      <td style={{ padding: '10px', border: '1px solid #eee', textAlign: 'center' }}>
                        <button
                          style={{
                            background: '#ff4d4f',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 6,
                            padding: '6px 16px',
                            fontSize: 14,
                            cursor: 'pointer',
                            fontWeight: 500
                          }}
                          onClick={async () => {
                            if (!window.confirm('确定要删除该填写记录吗？')) return;
                            const ok = await deleteSubFormById(rec.id);
                            if (ok) {
                              // 刷新列表
                              setRecords(records => records.filter(r => r.id !== rec.id));
                              setTotal(t => t - 1);
                            }
                          }}
                        >删除</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* 分页控件 */}
            <div style={{ textAlign: 'center', margin: '32px 0' }}>
              <button
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
                style={{
                  marginRight: 8,
                  padding: '6px 16px',
                  borderRadius: 6,
                  border: '1px solid #d9d9d9',
                  background: page === 1 ? '#f5f5f5' : '#fff',
                  color: page === 1 ? '#bbb' : '#1890ff',
                  cursor: page === 1 ? 'not-allowed' : 'pointer',
                  fontWeight: 500,
                  transition: 'all 0.2s'
                }}
              >上一页</button>
              <span style={{
                display: 'inline-block',
                minWidth: 80,
                fontWeight: 600,
                color: '#222',
                background: '#f7f7fa',
                borderRadius: 6,
                padding: '6px 18px',
                margin: '0 8px',
                border: '1px solid #e0e0e0'
              }}>
                第 <span style={{ color: '#1890ff', fontWeight: 700 }}>{page}</span> / {totalPages} 页
              </span>
              <button
                disabled={page >= totalPages}
                onClick={() => setPage(page + 1)}
                style={{
                  marginLeft: 8,
                  padding: '6px 16px',
                  borderRadius: 6,
                  border: '1px solid #d9d9d9',
                  background: page >= totalPages ? '#f5f5f5' : '#fff',
                  color: page >= totalPages ? '#bbb' : '#1890ff',
                  cursor: page >= totalPages ? 'not-allowed' : 'pointer',
                  fontWeight: 500,
                  transition: 'all 0.2s'
                }}
              >下一页</button>
            </div>
          </>
        )}
      </div>
      
      {/* 导出Excel模态框 */}
      <ExportExcelModal
        formId={formId}
        visible={showExportModal}
        onClose={() => setShowExportModal(false)}
      />
    </div>
  );
} 